export const meta = {
  id: 'G03',
  slug: 'recuperar-senha',
  title: 'Como recuperar sua senha',
  description: 'Solicite um link de recuperação quando não conseguir entrar no Personagrama.',
  profile: 'student',
  category: 'acesso',
  type: 'task',
  status: 'published',
  order: 40,
  keywords: ['senha', 'esqueci senha', 'recuperar', 'não consigo entrar', 'login', 'acesso'],
  previous: 'G01',
  next: 'A01',
  updatedAt: '2026-08-17',
  appVersion: 'v1'
}

# Como recuperar sua senha

Use a recuperação de senha quando sua conta já estiver ativa, mas você não lembrar a senha de acesso.

## Como fazer

<Steps>
  <Step title="Abra a tela de login">
    Selecione a opção de recuperação de senha.
  </Step>
  <Step title="Informe seu e-mail">
    Use o e-mail vinculado à sua conta do Personagrama.
  </Step>
  <Step title="Solicite a recuperação">
    Envie a solicitação e confira seu e-mail.
  </Step>
  <Step title="Abra o link recebido">
    Defina uma nova senha e volte à tela de login.
  </Step>
</Steps>

<HelpImage alt="Tela de recuperação de senha do Personagrama" pendingId="G03.1" />

<Callout type="tip">
  Se a mensagem não aparecer, confira também a pasta de spam ou lixo eletrônico. Quando a tela oferecer **Enviar novamente**, você poderá solicitar outro envio.
</Callout>

## O que acontece depois

Com a nova senha definida, volte ao login e entre normalmente no Personagrama.
